module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Sweet_diameter.42ec4355.png";